export const SET_LATEST_PAYROLLS_LIST = 'payroll/SET_LATEST_PAYROLLS_LIST';
export const SET_DATES_WITH_PAYROLLS = 'payroll/SET_DATES_WITH_PAYROLLS';
